import { Calendar, Clock, MapPin, Users, Star } from 'lucide-react';
import { format } from 'date-fns';

const ClassInfoSection = ({ classData, appliedDiscount }) => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-4xl sm:text-5xl font-black mb-2" data-testid="class-title">
          {classData.title}
        </h1>
        <p className="text-lg text-primary font-medium">{classData.instructor}</p>
      </div>

      <p className="text-neutral-300 text-base leading-relaxed">
        {classData.description}
      </p>

      <div className="grid grid-cols-2 gap-4">
        <div className="bg-background-paper border border-white/10 rounded-sm p-4">
          <div className="flex items-center gap-2 text-neutral-400 mb-1">
            <Calendar className="w-5 h-5 text-primary" />
            <span className="text-xs uppercase tracking-wider">Date</span>
          </div>
          <p className="font-bold text-lg">{format(new Date(classData.class_datetime), 'MMM dd, yyyy')}</p>
          <p className="text-sm text-neutral-400">{format(new Date(classData.class_datetime), 'h:mm a')}</p>
        </div>

        <div className="bg-background-paper border border-white/10 rounded-sm p-4">
          <div className="flex items-center gap-2 text-neutral-400 mb-1">
            <Clock className="w-5 h-5 text-primary" />
            <span className="text-xs uppercase tracking-wider">Duration</span>
          </div>
          <p className="font-bold text-lg">{classData.duration} min</p>
        </div>

        <div className="bg-background-paper border border-white/10 rounded-sm p-4">
          <div className="flex items-center gap-2 text-neutral-400 mb-1">
            <MapPin className="w-5 h-5 text-primary" />
            <span className="text-xs uppercase tracking-wider">Location</span>
          </div>
          <p className="font-bold text-lg">{classData.location || 'Main Studio'}</p>
          {classData.location_address && (
            <p className="text-sm text-neutral-400 mt-1">{classData.location_address}</p>
          )}
        </div>

        <div className="bg-background-paper border border-white/10 rounded-sm p-4">
          <div className="flex items-center gap-2 text-neutral-400 mb-1">
            <Users className="w-5 h-5 text-primary" />
            <span className="text-xs uppercase tracking-wider">Spots</span>
          </div>
          <p className="font-bold text-lg">{classData.spots_available} / {classData.capacity}</p>
          <p className="text-sm text-neutral-400">Available</p>
        </div>
      </div>

      {/* Price */}
      <div className="bg-background-paper border border-white/10 rounded-sm p-4">
        <div className="flex items-center justify-between">
          <span className="text-neutral-400">Price</span>
          {appliedDiscount ? (
            <div className="text-right">
              <span className="text-neutral-500 line-through text-lg mr-2">£{classData.price}</span>
              <span className="font-bold text-3xl text-success">£{appliedDiscount.final_price}</span>
            </div>
          ) : (
            <span className="font-bold text-3xl text-primary">£{classData.price}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClassInfoSection;
